// extracted by mini-css-extract-plugin
export default {"ButtonControl":"SingleControl_ButtonControl__zo7sy"};